module.exports = __webpack_public_path__ + "img/20190903145120928.5d29814f.jpg";